const initfullWidthBannerSlider = () => {
    const fullWidthBannerSliderWidget = document.querySelector("[data-full-width-banner-slider-widget]");
    if (fullWidthBannerSliderWidget) {
        const config = new CarouselConfig();
        config.sliderSelector = "[data-big-carousel-heading]";
        config.cellAlign = CellAlign.left;
        config.contain = true;
        config.autoPlay = false;
        config.wrapAround = false;
        config.showArrows = false;
        config.showArrows = false;
        config.showDots = true;
        config.groupCells = true;
        config.adaptiveHeight = true;
        config.imagesLoaded = true;
        const responsiveCarousel = new ResponsiveCarousel();
        const createdCarouselsArray = responsiveCarousel.initCarousel(config);
        //if slide changes, then check image color
        createdCarouselsArray.forEach(carousel => {
            carousel.on("change", () => {
                initBackgroundColorDetector();
            });
        });
    }
};
